<template>
  <Catalog
    title="Услуги самозанятых"
    name-label="Название услуги"
    submit-error="Укажите название услуги."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "WorkService",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkServicesById(id);
    },
    async putData(data) {
      return await this.putWorkServices(data);
    },
    async postData(data) {
      return await this.postWorkServices(data);
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkServices/WorkService.vue